import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { useStore } from 'state'

export const PostHogTracker = () => {
  const { store, event } = useStore()
  const { postHogTrackPageView, postHogTrackPageLeave } = usePostHogAnalytics()
  const location = useLocation()
  const lastPageView = useRef()

  const handlePageLeave = (url) => {
    const enterTime = parseInt(window.sessionStorage.getItem('enterTime'), 10)
    const leaveTime = Date.now()
    const timeOnPage = (leaveTime - enterTime) / 1000 // en segundos
    postHogTrackPageLeave(url, timeOnPage)
  }

  useEffect(() => {
    if (!store || !event || !postHogTrackPageView || !postHogTrackPageLeave) return

    // Capturar pageleave cuando cambia la ruta
    if (lastPageView.current && lastPageView.current !== window.location.href) {
      handlePageLeave(lastPageView.current)
    }

    // Capturar pageview de la nueva página
    if (lastPageView.current !== window.location.href) {
      postHogTrackPageView()
      lastPageView.current = window.location.href
      window.sessionStorage.setItem('enterTime', Date.now().toString())
    }

    // Capturar pageleave cuando se cierra la pestaña
    const handleBeforeUnload = () => {
      if (lastPageView.current) {
        handlePageLeave(lastPageView.current)
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [store, event, postHogTrackPageView, postHogTrackPageLeave, location.pathname])

  return null
}
